import { withProps as reWithprops, compose } from 'recompose';

const withProps = transformFunc => Component => {
  const withPropTransform = compose(reWithprops(transformFunc))(Component);

  withPropTransform.displayName = Component.displayName;
  withPropTransform.fragment = Component.fragment;

  return withPropTransform;
};

export default withProps;
